'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$64() {
  this.bFx = null;
  this.bFy = false;
}
export { $c_Lpresto_TwoFactorAuthView$$anon$64 as $c_Lpresto_TwoFactorAuthView$$anon$64 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$64.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$64;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$64() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$64 as $h_Lpresto_TwoFactorAuthView$$anon$64 };
$h_Lpresto_TwoFactorAuthView$$anon$64.prototype = $p;
$p.P = (function() {
  if ((!this.bFy)) {
    this.bFx = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T8($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$()));
    this.bFy = true;
  }
  return this.bFx;
});
var $d_Lpresto_TwoFactorAuthView$$anon$64 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$64, "presto.TwoFactorAuthView$$anon$64", ({
  Tp: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$64 as $d_Lpresto_TwoFactorAuthView$$anon$64 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$64.js.map
